export default __webpack_public_path__ + "static/media/Copper-coil-bent-tube.cd4f7b1a.jpg";